import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

// types
import { PdpSharedVisuallySimilarItemsCarouselLazy_user$key } from './__generated__/PdpSharedVisuallySimilarItemsCarouselLazy_user.graphql';
import { PdpSharedVisuallySimilarItemsCarouselLazy_viewer$key } from './__generated__/PdpSharedVisuallySimilarItemsCarouselLazy_viewer.graphql';
import { PdpSharedVisuallySimilarItemsCarouselLazy_item$key } from './__generated__/PdpSharedVisuallySimilarItemsCarouselLazy_item.graphql';

export const PdpSharedVisuallySimilarItemsCarousel = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedVisuallySimilarItemsCarousel" */ './PdpSharedVisuallySimilarItemsCarousel'
        )
);

const viewerFragment = graphql`
    fragment PdpSharedVisuallySimilarItemsCarouselLazy_viewer on Viewer {
        ...PdpSharedVisuallySimilarItemsCarousel_viewer
    }
`;

const userFragment = graphql`
    fragment PdpSharedVisuallySimilarItemsCarouselLazy_user on User {
        ...PdpSharedVisuallySimilarItemsCarousel_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedVisuallySimilarItemsCarouselLazy_item on Item {
        ...PdpSharedVisuallySimilarItemsCarousel_item
    }
`;

export const PdpSharedVisuallySimilarItemsCarouselLazy: FC<{
    viewer: PdpSharedVisuallySimilarItemsCarouselLazy_viewer$key;
    item: PdpSharedVisuallySimilarItemsCarouselLazy_item$key;
    user?: PdpSharedVisuallySimilarItemsCarouselLazy_user$key | null;
    afterDisplay: boolean;
    currency: string;
}> = ({ viewer: viewerRef, user: userRef, item: itemRef, afterDisplay, currency }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);

    return (
        <ClientSuspense fallback={null}>
            <PdpSharedVisuallySimilarItemsCarousel
                viewer={viewer}
                item={item}
                user={user}
                afterDisplay={afterDisplay}
                currency={currency}
            />
        </ClientSuspense>
    );
};
